import QRCode from 'react-qr-code'
import { useTranslation } from '../../hooks/useTranslation'
import { amountCurrency } from '../../lib/format'
import Overlay, { amountClass, headlineClass, subClass } from './Overlay'

export default function PaymentOverlay({
  kind,
  url,
  amount,
  currency,
}: {
  kind: 'mobilepay' | 'receipt'
  url: string
  amount: number
  currency: string
}) {
  const { t, locale } = useTranslation()
  const headline = kind === 'mobilepay' ? 'mobilepay-scan-to-pay' : 'receipt-scan-to-download'
  const sub = kind === 'mobilepay' ? 'mobilepay-scan-to-pay-sub' : 'receipt-scan-to-download-sub'

  return (
    <Overlay
      icon={<img src="/images/scan.png" alt="" className="h-[60%] w-[60%]" />}
      iconClass="bg-accent/[0.12] text-accent border-accent/30"
    >
      <div className={headlineClass}>{t(headline)}</div>
      <div className={subClass}>{t(sub)}</div>
      <div className={amountClass}>{amountCurrency(amount, currency, locale)}</div>
      <div
        data-testid="payment-qr-container"
        className="mt-[clamp(12px,2.2vh,28px)] h-[clamp(200px,38vh,340px)] w-[clamp(200px,38vh,340px)] rounded-xl border border-divider bg-white p-2.5 shadow-[0_4px_30px_rgba(39,42,48,0.1)]"
      >
        {kind === 'mobilepay' ? (
          <img src={url} alt="Payment QR Code" className="h-full w-full" />
        ) : (
          <QRCode value={url} style={{ height: '100%', width: '100%' }} />
        )}
      </div>
    </Overlay>
  )
}
